import type { DeepLinkCampaign } from '../../models/MasterAdmin/deepLink';

export type DeepLinkAssignmentValue = {
  deepLinkCampaignId?: string | null;
  deepLinkUrlType?: 'short' | 'full' | 'dynamic';
  deepLinkParamBindings?: Record<string, string>;
};

const PRODUCTION_DEEP_LINK_ORIGIN = 'https://vedika.health';

function rebuildShortUrlFromCode(campaign: DeepLinkCampaign): string {
  const code = String(campaign.shortCode || '').trim();
  if (!code) return '';
  const prefix = campaign.targetAppKey === 'plus' ? '/p/' : '/u/';
  return `${PRODUCTION_DEEP_LINK_ORIGIN}${prefix}${code}`;
}

function normalizeStoredCampaignUrl(raw: string): string {
  let u = String(raw || '').trim();
  if (!u) return '';
  if (/localhost|127\.0\.0\.1|192\.168\.|10\.\d+\.|172\.(1[6-9]|2\d|3[0-1])\./i.test(u)) {
    u = u.replace(/^https?:\/\/[^/]+/i, PRODUCTION_DEEP_LINK_ORIGIN);
  }
  return u.split('?')[0];
}

function looksLikeBareHomepage(url: string): boolean {
  return /^https:\/\/vedika\.health\/?$/i.test(String(url || '').trim());
}

/** Prefer live shortCode → /u|/p URL; never fall back to bare https://vedika.health. */
export function previewDeepLinkFromCampaign(
  value: DeepLinkAssignmentValue,
  campaignsById: Map<string, DeepLinkCampaign>
): string {
  const id = value.deepLinkCampaignId?.trim();
  if (!id) return '';
  const campaign = campaignsById.get(id);
  if (!campaign) return '';

  const fromCode = rebuildShortUrlFromCode(campaign);
  const urlType = value.deepLinkUrlType || 'short';
  let resolved = '';
  if (urlType === 'full') {
    resolved =
      normalizeStoredCampaignUrl(campaign.fullUrl || '') ||
      fromCode ||
      normalizeStoredCampaignUrl(campaign.shortUrl || '');
  } else {
    resolved =
      fromCode ||
      normalizeStoredCampaignUrl(campaign.shortUrl || '') ||
      normalizeStoredCampaignUrl(campaign.fullUrl || '');
  }
  if (!resolved || looksLikeBareHomepage(resolved)) return fromCode || '';
  return resolved.replace(/\/$/, '');
}
